import { render, staticRenderFns } from "./RimborsoInteressi.vue?vue&type=template&id=c5b462fc&scoped=true"
import script from "./RimborsoInteressi.vue?vue&type=script&lang=js"
export * from "./RimborsoInteressi.vue?vue&type=script&lang=js"
import style0 from "./RimborsoInteressi.vue?vue&type=style&index=0&id=c5b462fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b462fc",
  null
  
)

export default component.exports